import Alert from '@cloudscape-design/components/alert'
import Box from '@cloudscape-design/components/box'
import Button from '@cloudscape-design/components/button'
import SpaceBetween from '@cloudscape-design/components/space-between'
import { logout } from '@/clients/firebase'
import { useAuthStore } from '@/state/authStore'

export default function StatusPage() {
  const status = useAuthStore((s) => s.status)

  const handleLogout = async () => {
    await logout()
  }

  if (status === 'suspended') {
    return (
      <Box padding="xxl">
        <SpaceBetween size="m">
          <Alert type="error" header="Account suspended">
            Your account has been suspended. Please contact support for assistance.
          </Alert>
          <Button onClick={() => void handleLogout()}>Sign out</Button>
        </SpaceBetween>
      </Box>
    )
  }

  // Default: pending approval
  return (
    <Box padding="xxl">
      <Alert type="info" header="Account pending approval">
        Your account is currently pending approval. You will be notified once it has been reviewed.
      </Alert>
    </Box>
  )
}
